// extracted by mini-css-extract-plugin
module.exports = {"vehicleListNavBackground":"PageComposer_vehicleListNavBackground__TgTlm"};